import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_sort_down",
  "use": "icon-icon_sort_down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_sort_down\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"m8.48 12.36 1.8-2.4A.6.6 0 0 0 9.8 9H6.2a.6.6 0 0 0-.48.96l1.8 2.4a.6.6 0 0 0 .96 0Z\" fill=\"#2E5BFD\" fill-rule=\"nonzero\" /><path d=\"m7.52 3.64-1.8 2.4A.6.6 0 0 0 6.2 7h3.6a.6.6 0 0 0 .48-.96l-1.8-2.4a.6.6 0 0 0-.96 0Z\" fill=\"#57595E\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol